import { render } from "./OfficeRequestMain.vue?vue&type=template&id=0ac76d05&scoped=true"
import script from "./OfficeRequestMain.vue?vue&type=script&lang=js"
export * from "./OfficeRequestMain.vue?vue&type=script&lang=js"

import "./OfficeRequestMain.vue?vue&type=style&index=0&id=0ac76d05&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac76d05"]])

export default __exports__